import { combineReducers } from 'redux';
import employeeReducer from './employeeReducer';
import positionReducer from './positionReducer';
import authReducer from './authReducer';
import departmentReducer from './departmentReducer';
import projectTypeReducer from './projectTypeReducer';
import omProjectReducer from './omProjectReducer';
import commonReducer from './commonReducer';
import projectReducer from './projectReducer';
import inquiryDataReducer from './inquiryDataReducer';
import workingHourReducer from './workingHourReducer';
import approveReducer from './approveReducer';
import totalRecordByDateReducer from './totalRecordByDateReducer';
import totalRecordByDateReducer2 from './totalRecordByDateReducer2';
import totalRecordByProjectReducer from './totalRecordByProjectReducer';
import projectEmployeeSortReducer from './projectEmployeeSortReducer';
import shiftControlReducer from './shiftControlReducer';
import totalRecordDetailReducer from './totalRecordDetailReducer';
import addNewProjectReducer from './addNewProjectReducer';
import departmentAndEmployeeReducer from './departmentAndEmployeeReducer';
import departmentAndEmployeeReducerExport from './departmentAndEmployeeReducerExport';
import newLeaveRequestReducer from './newLeaveRequestReducer';
import myLeaveRequestReducer from './myLeaveRequestReducer';
import leaveHolidayReducer from './leaveHolidayReducer';
import leaveConfigReducer from './leaveConfigReducer';
import allLeaveRequestReducer from './allLeaveRequestReducer';
import leaveHistoryReducer from './leaveHistoryReducer';
import leaveDetailReducer from './leaveDetailReducer';
import leaveOverviewReducer from './leaveOverviewReducer';
import updateRequestReducer from './updateRequestReducer';
import checkExportInquiryReducer from './checkExportInquiryReducer';

import {connectRouter} from 'connected-react-router';

import util from '../helpers/util';

export default combineReducers({
    commonReducer,
    employeeReducer,
    positionReducer,
    departmentReducer,
    authReducer,
    projectTypeReducer,
    omProjectReducer,
    projectReducer,
    inquiryDataReducer,
    workingHourReducer,
    approveReducer,
    totalRecordByDateReducer,
    totalRecordByDateReducer2,
    totalRecordByProjectReducer,
    projectEmployeeSortReducer,
    shiftControlReducer,
    totalRecordDetailReducer,
    addNewProjectReducer,
    router: connectRouter(util.history),
    departmentAndEmployeeReducer,
    departmentAndEmployeeReducerExport,
    newLeaveRequestReducer,
    myLeaveRequestReducer,
    leaveHolidayReducer,
    leaveConfigReducer,
    allLeaveRequestReducer,
    leaveHistoryReducer,
    leaveDetailReducer,
    leaveOverviewReducer,
    updateRequestReducer,
    checkExportInquiryReducer
});
